import React from 'react';
import "../../css/buttons/BulletPoint.css"

const BulletPoint = ({ color }) => {
    
    const background = color + "52"

    return (
        <div className="BulletPoint" style={{ backgroundColor: background }}>
            <span
                className="bullet-point-center"
                style={{ backgroundColor: color }}
            ></span>
        </div>
    );
};

export default BulletPoint;
